/**
 * MG Time Tracker Application
 *	SearchSelectListItem.js
 */

import React, { Component } from 'react';
import _ from 'underscore';

class SearchSelectListItem extends Component {

    onSelectItem (item) {
        this.props.onSelectItem(item);
    }

    _renderButton (buttonProps) {
        const item = this.props.item;
        const ButtonText = _.isFunction(this.props.selectText)
            ? this.props.selectText(item)
            : this.props.selectText;

        return (
            <button
                ref="button"
                className={this.props.buttonStyle}
                onClick={() => {
                    this.props.onSelectItem(item, this.refs.button);
                    this.forceUpdate();
                }}
                {...buttonProps}
            >{ButtonText}</button>
        );
    }

    _renderFavoriteButton () {
        const item = this.props.item;
        const isFavorite = this.props.item.isFavorite();
        const label = (isFavorite) ? "\u2605" : "\u2606";

        return (
            <button
                ref="button"
                className='btn btn-default btn-favorite'
                onClick={() => {
                    if (isFavorite) {
                        this.props.onRemoveFavoriteItem(item, this.refs.button);
                    } else {
                        this.props.onFavoriteItem(item, this.refs.button);
                    }
                }}
            >{label}</button>
        );
    }

    render () {
        const item = this.props.item;
        const hasFavoriteButton = this.props.hasAddToFavorites;
        let mainCols = this.props.mainColSize;
        let rowClassNames = this.props.rowClassName || "";
        let Buttons = null;
        let FavoriteButton = null;

        if (this.props.actions) {
            Buttons = this.props.actions(item);

        } else {
            let buttonProps = _.isFunction(this.props.buttonProps)
                ? this.props.buttonProps(item)
                : this.props.buttonProps;

            Buttons = this._renderButton(buttonProps);
        }

        if (hasFavoriteButton) {
            FavoriteButton = this._renderFavoriteButton();
            mainCols -= 2;
        }

        return (
            <div className={
                `searchSelectListItem vertical-align row ${rowClassNames}`
            }>
                <div className={`col-${this.props.colType}-${mainCols} description`}>
                    <div>{FavoriteButton}</div>&nbsp;
                    <div>{React.Children.toArray(this.props.children)}</div>
                </div>
                <div className={
                    `col-${this.props.colType}-${12 - mainCols} itemButton`
                }>{Buttons}</div>
            </div>
        );
    }
}

SearchSelectListItem.defaultProps = {
    item: {},
    mainColSize: 10,
    colType: 'sm',
    rowClassName: '',
    selectText: 'Select',
    buttonStyle: 'btn btn-primary'
};

export default SearchSelectListItem;



// WEBPACK FOOTER //
// ./app/components/SelectLists/SearchSelectListItem.jsx